import { render } from "./VerticalTab.vue?vue&type=template&id=16bc94d6"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__